/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, {
  useMemo,
  useLayoutEffect,
  useEffect,
  useState,
  useRef,
} from "react";
import objectPath from "object-path";
import { useLocation } from "react-router-dom";
import { QuickActions } from "./components/QuickActions";
import { BreadCrumbs } from "./components/BreadCrumbs";
import {
  getBreadcrumbsAndTitle,
  useSubheader,
} from "../../_core/MetronicSubheader";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { Dropdown, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_helpers";
import { SearchResult } from "../extras/dropdowns/search/SearchResult";
import { SearchDropdown } from "../extras/dropdowns/search/SearchDropdown";
import clsx from "clsx";
import { DropdownTopbarItemToggler } from "../../../_partials/dropdowns";
import { fetchsearchSuggestion } from "../../../../actions/products/products";
import { useHistory } from "react-router-dom";
import {
  categoryFilter,
  searchKeyword,
  sortFilter,
  brandFilter,
} from "../../../../actions/common";
import { fetchBrandFilters } from "../../../../actions/products/products";
import { debounce } from "lodash";
import Select from "react-select";
import { getHomePageBanners } from "../../../../actions/marketing/marketing";
import BannerSlider from "../../../../app/pages/AllInventory/AllInventoryTable/BannerSlider";

export function SubHeader({ name }) {
  const uiService = useHtmlClassService();
  const location = useLocation();
  const subheader = useSubheader();

  // Keep a CSS variable with the current subheader height for sticky positioning
  useEffect(() => {
    const subheaderEl = document.getElementById("kt_subheader");
    if (!subheaderEl) return;

    const updateSubheaderHeightVar = () => {
      const rect = subheaderEl.getBoundingClientRect();
      const computed = window.getComputedStyle(subheaderEl);
      const marginBottom = parseFloat(computed.marginBottom || "0");
      const height = rect.height + marginBottom;
      document.documentElement.style.setProperty(
        "--subheader-height",
        `${Math.round(height)}px`
      );
    };

    // Settle loop to capture immediate wraps and async content changes
    const settleHeightVar = () => {
      let frames = 6; // ~100ms
      const tick = () => {
        updateSubheaderHeightVar();
        if (--frames > 0) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    updateSubheaderHeightVar();
    settleHeightVar();

    const ro = new ResizeObserver(() => settleHeightVar());
    try {
      ro.observe(subheaderEl);
    } catch (e) { }

    // Observe inner container where wrap occurs
    const container = subheaderEl.querySelector(".container, .container-fluid");
    if (container) {
      try {
        ro.observe(container);
      } catch (e) { }
    }

    // Watch for DOM/text changes
    const mo = new MutationObserver(() => settleHeightVar());
    try {
      mo.observe(subheaderEl, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    } catch (e) { }

    window.addEventListener("resize", updateSubheaderHeightVar);
    window.addEventListener("orientationchange", updateSubheaderHeightVar);
    window.addEventListener("load", updateSubheaderHeightVar);

    return () => {
      try {
        ro.disconnect();
      } catch (e) { }
      try {
        mo.disconnect();
      } catch (e) { }
      window.removeEventListener("resize", updateSubheaderHeightVar);
      window.removeEventListener("orientationchange", updateSubheaderHeightVar);
      window.removeEventListener("load", updateSubheaderHeightVar);
    };
  }, []);

  const layoutProps = useMemo(() => {
    return {
      config: uiService.config,
      subheaderMobileToggle: objectPath.get(
        uiService.config,
        "subheader.mobile-toggle"
      ),
      subheaderCssClasses: uiService.getClasses("subheader", true),
      subheaderContainerCssClasses: uiService.getClasses(
        "subheader_container",
        true
      ),
    };
  }, [uiService]);

  useLayoutEffect(() => {
    const aside = getBreadcrumbsAndTitle("kt_aside_menu", location.pathname);
    const header = getBreadcrumbsAndTitle("kt_header_menu", location.pathname);
    const breadcrumbs =
      aside && aside.breadcrumbs.length > 0
        ? aside.breadcrumbs
        : header.breadcrumbs;
    subheader.setBreadcrumbs(breadcrumbs);
    subheader.setTitle(
      aside && aside.title && aside.title.length > 0
        ? aside.title
        : header.title
    );
    // eslint-disable-next-line
  }, [location.pathname]);

  // Do not remove this useEffect, need from update title/breadcrumbs outside (from the page)
  useEffect(() => { }, [subheader]);

  // get myinventory count
  const { count } = useSelector(
    (state) => ({
      count:
        state.products &&
        state.products.myinventoryproduct &&
        state.products.myinventoryproduct.totalDocs,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  const fakeData = [
    {
      type: 0,
      text: "Reports",
    },
    {
      type: 1,
      text: "AirPlus Requirements",
      description: "by Grog John",
      iconImage: toAbsoluteUrl("/media/files/doc.svg"),
    },
    {
      type: 1,
      text: "TechNav Documentation",
      description: "by Mary Brown",
      iconImage: toAbsoluteUrl("/media/files/pdf.svg"),
    },
    {
      type: 1,
      text: "All Framework Docs",
      description: "by Grog John",
      iconImage: toAbsoluteUrl("/media/files/zip.svg"),
    },
    {
      type: 1,
      text: "AirPlus Requirements",
      description: "by Tim Hardy",
      iconImage: toAbsoluteUrl("/media/files/xml.svg"),
    },
    {
      text: "Customers",
      type: 0,
    },
    {
      type: 1,
      text: "Jimmy Curry",
      description: "Software Developer",
      iconImage: toAbsoluteUrl("/media/users/300_11.jpg"),
    },
    {
      type: 1,
      text: "Milena Gibson",
      description: "UI Designer",
      iconImage: toAbsoluteUrl("/media/users/300_16.jpg"),
    },
    {
      type: 1,
      text: "Stefan JohnStefan",
      description: "Marketing Manager",
      iconImage: toAbsoluteUrl("/media/users/300_22.jpg"),
    },
    {
      type: 1,
      text: "Anna Strong",
      description: "Software Developer",
      iconImage: toAbsoluteUrl("/media/users/300_5.jpg"),
    },
    {
      type: 0,
      text: "Files",
    },
    {
      type: 1,
      text: "2 New items submitted",
      description: "Marketing Manager",
      iconClassName: "flaticon2-box font-danger",
    },
    {
      type: 1,
      text: "79 PSD files generated",
      description: "by Grog John",
      iconClassName: "flaticon-psd font-brand",
    },
    {
      type: 1,
      text: "$2900 worth products sold",
      description: "Total 234 items",
      iconClassName: "flaticon2-supermarket font-warning",
    },
    {
      type: 1,
      text: "4 New items submitted",
      description: "Marketing Manager",
      iconClassName: "flaticon-safe-shield-protection font-info",
    },
  ];

  const [anchorEl, setAnchorEl] = useState(null);
  const suggestionBoxOpen = Boolean(anchorEl);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const dropdownRef = useRef(null); // Ref for dropdown toggle
  const [showDropdown, setShowDropdown] = useState(false);
  const [recentSearches, setRecentSearches] = useState([]);
  const [suggestions, setsuggestions] = useState([]);

  const [clearSearchflag, setclearSearchflag] = useState(false);
  const [selctedsortValue, setselctedsortValue] = useState("new_to_old");
  const [selectedBrandValue, setSelectedBrandValue] = useState("All");
  const [brandFilters, setBrandFilters] = useState([]);
  const [isBrandMenuOpen, setIsBrandMenuOpen] = useState(false);
  const [isSortMenuOpen, setIsSortMenuOpen] = useState(false);
  let timeoutId;

  const timeoutRef = useRef(null);

  const history = useHistory();

  const headerMenu = [
    "/my-orders",
    "/marketing-material",
    "/my-account",
    "/help",
    "/return",
    "/cart",
    "/trunkey",
    "/upgrade-save",
    "/pricing-rule",
    "/pricing-rule-details",
    "/help-sold-out-product",
  ];

  const { categories, searchKey, sortValue, brandValue } = useSelector(
    (state) => ({
      categories: state.common && state.common?.categoryID,
      searchKey: state.common && state.common?.searchKeyword,
      sortValue: state.common && state.common?.sortFilter,
      brandValue: state.common && state.common?.brandFilter,
    }),
    shallowEqual
  );

  // Load previous search history from localStorage
  useEffect(() => {
    const storedSearches =
      JSON.parse(localStorage.getItem("recentSearches")) || [];
    setRecentSearches(storedSearches);
  }, []);

  // Fetch brand filters on component mount
  useEffect(() => {
    const loadBrandFilters = async () => {
      const brands = await dispatch(fetchBrandFilters());
      setBrandFilters(brands);
    };
    loadBrandFilters();
  }, []);

  // Save recent searches to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem("recentSearches", JSON.stringify(recentSearches));
  }, [recentSearches]);

  const handleSearch = (searchTerm) => {
    const trimmedSearchTerm = searchTerm.trim();
    if (!trimmedSearchTerm) return; // Prevent empty searches

    // Add the new search term at the beginning and remove duplicates
    const updatedSearches = [
      trimmedSearchTerm,
      ...recentSearches.filter((s) => s !== trimmedSearchTerm),
    ].slice(0, 5); // Keep only the last 5 searches

    setRecentSearches(updatedSearches);
    // setSearchValue("") // Clear input field after search
  };

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  const handleSearchDebounced = debounce(async (event) => {
    event.persist();
    console.log(event.target.value, "newValue....");
    const searchBody = {
      query: event.target.value,
    };
    // setTimeout(async () => {
    setLoading(true);
    let suggestionsArray = await dispatch(fetchsearchSuggestion(searchBody));
    suggestionsArray = suggestionsArray.payload.data.suggestions || [];
    setsuggestions(suggestionsArray);
    setLoading(false);
    // }, 500)
  }, 500); // Adjust the delay time as needed

  const handleSearchChange = (event) => {
    event.persist();
    setData(null);
    setsuggestions([]);
    setSearchValue(event.target.value);
    handleSearchDebounced(event);
  };

  const clear = () => {
    setData(null);
    setSearchValue("");
    dispatch(searchKeyword({ searchKeyword: null }));
    // setShowDropdown(false)
    setAnchorEl(null);
    setsuggestions([]);
  };

  const handleInputFocus = (e) => {
    e.persist(); // Prevent React from clearing the event

    setTimeout(() => {
      // setShowDropdown(true)
      setAnchorEl(e.target);
    }, 500);

    if (searchValue.length === 0) {
      setData(recentSearches);
    }
  };

  // Remove a search term from localStorage
  const handleRemoveSearch = (termToRemove) => {
    setTimeout(() => {
      const updatedSearches = recentSearches.filter(
        (term) => term !== termToRemove
      );
      setRecentSearches(updatedSearches);
      setData(updatedSearches);
    }, 1000);
  };

  // check shop exist or not
  const path = window.location.href.replace(/^.+\?/i, "");
  const searchParams = new URLSearchParams(path);
  const shop = searchParams.get("shop");
  const host = searchParams.get("host");

  // const searchVal = () => {
  //   if (searchValue !== "") {
  //     if (headerMenu.includes(history?.location?.pathname)) {
  //       const redirectURL = `/all-inventory?shop=${shop}&host=${host}`
  //       history.push(redirectURL)
  //       setTimeout(() => {
  //         dispatch(searchKeyword({ searchKeyword: searchValue.trim() }))
  //         setclearSearchflag(true)
  //       }, 3000)
  //     } else {
  //       setTimeout(() => {
  //         dispatch(searchKeyword({ searchKeyword: searchValue.trim() }))
  //         setclearSearchflag(true)
  //       }, 2000)
  //     }

  //     // dispatch(searchKeyword({ searchKeyword: searchValue.trim() }))
  //     // setclearSearchflag(true)
  //     // getRedirectionURL(categories,searchValue.trim(),sortValue)
  //   }
  // }

  useEffect(() => {
    if (
      headerMenu.includes(history?.location?.pathname) &&
      (categories !== null ||
        searchKey !== null ||
        sortValue !== null ||
        brandValue !== null)
    ) {
      if (categories) {
        dispatch(categoryFilter({ categoryId: null }));
      }

      if (searchKey) {
        dispatch(searchKeyword({ searchKeyword: null }));
        setclearSearchflag(false);
        setSearchValue("");
      }

      if (brandValue) {
        dispatch(brandFilter({ brandFilter: null }));
        setSelectedBrandValue("All");
      }
      // console.log("Need to remove.......")
      // var redirectionURL = getRedirectionURL(categories,searchKey,sortValue)
      // var redirectionURL = '/all-inventory?shop=myonlineteststoreforapp.myshopify.com&host=YWRtaW4uc2hvcGlmeS5jb20vc3RvcmUvbXlvbmxpbmV0ZXN0c3RvcmVmb3JhcHA&bypass=22868300104343534024&redirect=true'
      // history.push(redirectionURL)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories, history.location.pathname, searchKey, brandValue]);

  useEffect(() => {
    if (categories !== null) {
      dispatch(searchKeyword({ searchKeyword: null }));
      setclearSearchflag(false);
      setSearchValue("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories]);

  useEffect(() => {
    if (brandValue !== null) {
      dispatch(searchKeyword({ searchKeyword: null }));
      setclearSearchflag(false);
      setSearchValue("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandValue]);

  useEffect(() => {
    if (sortValue) {
      setselctedsortValue(sortValue);
    } else {
      setselctedsortValue("new_to_old");
    }
  }, [sortValue]);

  useEffect(() => {
    if (brandValue) {
      setSelectedBrandValue(brandValue);
    } else {
      setSelectedBrandValue("All");
    }
  }, [brandValue]);

  const handsortingChange = (e) => {
    const newValue = e.target.value;
    const currentPath = history?.location?.pathname;
    // Redirect to All Inventory on any page that is not inventory pages
    if (currentPath !== "/all-inventory" && currentPath !== "/my-inventory") {
      const redirectURL = `/all-inventory?shop=${shop}&host=${host}`;
      history.push(redirectURL);
    }
    dispatch(sortFilter({ sortFilter: newValue }));
    setselctedsortValue(newValue);
  };

  const handleBrandChange = (e) => {
    const newValue = e.target.value;
    const currentPath = history?.location?.pathname;
    // Redirect to All Inventory on any page that is not inventory pages
    if (currentPath !== "/all-inventory" && currentPath !== "/my-inventory") {
      const redirectURL = `/all-inventory?shop=${shop}&host=${host}`;
      history.push(redirectURL);
    }
    // Clear categories when brand is selected so brand filter works independently
    if (newValue !== "All") {
      dispatch(categoryFilter({ categoryId: null }));
    }
    dispatch(
      brandFilter({ brandFilter: newValue === "All" ? null : newValue })
    );
    setSelectedBrandValue(newValue);
  };

  const handleSearchfromRecent = (searchTerm) => {
    if (searchTerm !== "") {
      if (headerMenu.includes(history?.location?.pathname)) {
        const redirectURL = `/all-inventory?shop=${shop}&host=${host}`;
        history.push(redirectURL);
        // setTimeout(() => {
        // Clear brand filter when searching to mirror category behavior
        dispatch(brandFilter({ brandFilter: null }));
        dispatch(searchKeyword({ searchKeyword: searchTerm.trim() }));
        setclearSearchflag(true);
        // }, 1000)
      } else {
        // setTimeout(() => {
        // Clear brand filter when searching to mirror category behavior
        dispatch(brandFilter({ brandFilter: null }));
        dispatch(searchKeyword({ searchKeyword: searchTerm.trim() }));
        setclearSearchflag(true);
        // }, 1000)
      }
    }
    setSearchValue(searchTerm);
    setAnchorEl(null);
    handleSearch(searchTerm);
    setsuggestions([]);
  };

  const handleKeypress = (e) => {
    if (e.keyCode === 13) {
      handleSearchfromRecent(searchValue);
      handleSearch(searchValue);
      setsuggestions([]);
    }
  };

  useEffect(() => {
    if (searchValue.length <= 0) {
      setData(recentSearches);
      setAnchorEl("something");
      dispatch(searchKeyword({ searchKeyword: null }));
    }
  }, [searchValue]);

  const shouldCloseSelectOnScroll = (event) => {
    const target = event?.target;
    if (!target || !(target instanceof Element)) {
      return true;
    }

    // Keep select menu open while scrolling inside its own options list.
    return !target.closest(".react-select__menu-list");
  };

  // Close all open dropdowns on scroll to avoid floating menus staying open.
  useEffect(() => {
    const handleScrollClose = () => {
      setAnchorEl(null);
      setIsBrandMenuOpen(false);
      setIsSortMenuOpen(false);
    };

    window.addEventListener("scroll", handleScrollClose, {
      passive: true,
    });
    return () => {
      window.removeEventListener("scroll", handleScrollClose, {
        passive: true,
      });
    };
  }, []);

  // Silder Banner Changes Added
  const [banners, setbanners] = useState([]);

  useEffect(() => {
    async function getAllbanners() {
      const bannerres = await dispatch(getHomePageBanners());

      if (bannerres && bannerres?.payload) {
        setbanners(bannerres?.payload);
      } else {
        setbanners([]);
      }
    }
    getAllbanners();
    // eslint-disable-next-line no-use-before-define
  }, [dispatch]);

  // Silder Banner Changes Added

  // justify-content-between
  return (
    <>
      {/* Added Slider in Subheader */}
      {location && location.pathname == "/all-inventory" && (
        <div class="hero-carousel bg-gradient-to-r from-gray-100 to-slate-100 text-black px-6 py-3 relative overflow-hidden flex-shrink-0">
          <BannerSlider banners={banners} />
        </div>
      )}
      {/* Added Slider in Subheader */}
      <div
        id="kt_subheader"
        className={`subheader ${layoutProps.subheaderCssClasses}`}
      >
        <div
          className={`${layoutProps.subheaderContainerCssClasses} w-100 sticky top-0 z-30 bg-white/90 backdrop-blur-md border-b border-slate-200 px-6 py-3 shadow-sm flex flex-col justify-between items-center`}
        >
          {layoutProps.subheaderMobileToggle && (
            <button
              className="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none"
              id="kt_subheader_mobile_toggle"
            >
              <span />
            </button>
          )}
          {/* <div className="d-flex align-items-baseline mr-5">
            <h5 className="text-dark font-weight-bold my-2 mr-5">
              <>
                {name? name?.title:subheader.title}
              </> */}
          {/*<small></small>*/}
          {/* </h5>
          </div> */}
          <BreadCrumbs
            items={name ? name?.breadcrumbs : subheader.breadcrumbs}
          />
          <div className="filter-sec-subheader d-flex justify-between items-center w-full gap-4">
            <div className="sub-header-left flex gap-2 w-auto sm:w-full flex-wrap flex-col items-start sm:flex-row sm:items-center">
              {location && location.pathname == "/my-inventory" && count >= 0 && (
                <div className="d-flex align-items-center total_item_btn">
                  <span
                    className="font-weight-bold my-count-section"
                    id="kt_dashboard_daterangepicker_title"
                  >
                    <strong>Total added items: {" "}</strong>
                  </span>
                  <span
                    className="font-weight-bolder my-count-section ml-1"
                    id="kt_dashboard_daterangepicker_date"
                  >
                    <strong>{count !== null ? count : 0}</strong>
                  </span>
                </div>
              )}
              <div id="subheader-selection-bar-container"></div>
            </div>
            <div className="sub-header-right flex items-center gap-3 w-auto sm:w-full flex-wrap">
              {location && location.pathname == "/my-inventory" && (
                <div className="sync-sec-subheader d-flex flex-row sm:flex-col gap-4" id="sync-sec-container">
                  {/* <button
                className="red-btn bg-brand-600 hover:bg-brand-700 text-white px-4 py-1.5 rounded-lg text-sm font-semibold transition-colors shadow-sm flex items-center gap-2 whitespace-nowrap"
              >
                Sale Products Price Resync
              </button>
              <button
                className="red-btn bg-brand-600 hover:bg-brand-700 text-white px-4 py-1.5 rounded-lg text-sm font-semibold transition-colors shadow-sm flex items-center gap-2 whitespace-nowrap"
              >
                Products Price Resync
              </button> */}
                </div>
              )}
              <div className="quick_search_sec">
                <div
                  id="kt_quick_search_dropdown"
                  className="quick-search quick-search-dropdown position-relative react_header_search"
                >
                  <div className="quick-search-form">
                    <div className="input-group">
                      {/* <div className="input-group-prepend" onClick={() => handleSearchfromRecent(searchValue)} style={{ cursor: "pointer" }}>
                        <span className="input-group-text bg-transparent border-right-0">
                          <i
                            className={`fa-solid fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400`}
                          />
                        </span>
                      </div> */}
                      <i
                        className={`fa-solid fa-search absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-400`}
                      />
                      <input
                        id="header_search"
                        type="text"
                        placeholder="Search inventory by keyword or SKU..."
                        value={searchValue}
                        onChange={handleSearchChange}
                        className="form-control adv_search w-full bg-slate-100 border-none rounded-full py-2 pl-10 pr-4 text-sm focus:ring-2 focus:ring-brand-500 outline-none transition-shadow"
                        onKeyDown={handleKeypress}
                        onFocus={handleInputFocus}
                        onClick={handleInputFocus}
                      />
                      <div
                        className={`input-group-append ${loading ? "spinner spinner-sm spinner-primary" : ""
                          }`}
                      >
                        <span className="input-group-text bg-transparent border-left-0" style={{ cursor: searchValue ? "pointer" : "default", minWidth: "40px", display: "flex", justifyContent: "center" }} onClick={searchValue ? () => clear() : undefined}>
                          <i
                            style={{ display: (!loading && searchValue) ? "flex" : "none" }}
                            className={`quick-search-close fa fa-times icon-md text-muted`}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="adv_search_dropdown w-100">
                    <Dropdown show={suggestionBoxOpen} onToggle={setAnchorEl}>
                      <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic"
                        ref={dropdownRef}
                        className="d-none"
                      />
                      <Dropdown.Menu
                        className="dropdown-menu p-0 m-0 dropdown-menu-anim-up dropdown-menu-lg dropdown-menu-xl"
                        style={{
                          width: "100%",
                          left: "0 !important",
                          right: "auto !important",
                          transform: "none !important",
                          position: "absolute",
                          top: "100%",
                          marginLeft: "0 !important",
                          paddingLeft: "0 !important",
                        }}
                      >
                        <div
                          className={clsx("quick-search quick-search-popup", {
                            "quick-search-has-result":
                              (suggestions && suggestions.length) ||
                              (data && data.length),
                          })}
                        >
                          <SearchResult
                            data={data}
                            suggestions={suggestions}
                            handleRemoveSearch={handleRemoveSearch}
                            handleSearchfromRecent={handleSearchfromRecent}
                          />
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
              <div className="select_filter"
                style={{ minWidth: "105px", maxWidth: "105px" }}
              >
                {/* <label
                    htmlFor="brand_filter"
                    className="mb-0 mr-3 text-muted font-weight-bold d-none d-sm-inline-block brand_filter_label"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Brand
                  </label> */}
                <div className="w-100">
                  <Select
                    inputId="brand_filter"
                    classNamePrefix="react-select"
                    className="react-select-container"
                    menuIsOpen={isBrandMenuOpen}
                    onMenuOpen={() => setIsBrandMenuOpen(true)}
                    onMenuClose={() => setIsBrandMenuOpen(false)}
                    value={
                      selectedBrandValue === "All"
                        ? { value: "All", label: "All Brands" }
                        : (() => {
                          const selectedBrand = brandFilters.find(
                            (b) => b?.name?.trim() === selectedBrandValue
                          );
                          return selectedBrand
                            ? {
                              value: selectedBrand.name?.trim(),
                              label: selectedBrand?.isFeatured
                                ? `⭐ ${selectedBrand.name.trim()}`
                                : selectedBrand.name.trim(),
                            }
                            : {
                              value: selectedBrandValue,
                              label: selectedBrandValue,
                            };
                        })()
                    }
                    onChange={(opt) =>
                      handleBrandChange({ target: { value: opt?.value || "All" } })
                    }
                    options={[
                      { value: "All", label: "All Brands" },
                      ...(brandFilters?.some((b) => b?.isFeatured)
                        ? [
                          {
                            label: "FEATURED BRANDS",
                            options: brandFilters
                              .filter((b) => b.isFeatured)
                              .map((b) => ({
                                value: b.name?.trim(),
                                label: `⭐ ${b.name.trim()}`,
                              })),
                          },
                        ]
                        : []),
                      {
                        label: "Browse All",
                        options: brandFilters
                          ?.filter((b) => !b?.isFeatured)
                          .map((b) => ({
                            value: b.name?.trim(),
                            label: b.name.trim(),
                          })),
                      },
                    ]}

                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                    closeMenuOnScroll={shouldCloseSelectOnScroll}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      groupHeading: (base) => ({
                        ...base,
                        fontWeight: "bold",
                        fontSize: "13px",
                        color: "#555",
                        background: "#f7f7f7",
                        padding: "6px 8px",
                        borderBottom: "1px solid #eee",
                      }),
                    }}
                  />

                </div>
              </div>
              <div className="select_filter"
                style={{ minWidth: "170px", maxWidth: "170px" }}
              >
                {/* <label
                    htmlFor="filter_by"
                    className="mb-0 mr-3 text-muted font-weight-bold d-none d-sm-inline-block brand_filter_label"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    Filter By
                  </label> */}
                <div className="w-100">
                  <Select
                    inputId="filter_by"
                    classNamePrefix="react-select"
                    className="react-select-container"
                    menuIsOpen={isSortMenuOpen}
                    onMenuOpen={() => setIsSortMenuOpen(true)}
                    onMenuClose={() => setIsSortMenuOpen(false)}
                    value={{
                      value: selctedsortValue,
                      label:
                        selctedsortValue === "new_to_old"
                          ? "Newest to Oldest"
                          : selctedsortValue === "old_to_new"
                            ? "Oldest to Newest"
                            : selctedsortValue === "low_to_high"
                              ? "Cost: Low to High"
                              : selctedsortValue === "high_to_low"
                                ? "Cost: High to Low"
                                : selctedsortValue === "qty_low_to_high"
                                  ? "Qty: Low to High"
                                  : "Qty: High to Low",
                    }}
                    onChange={(opt) =>
                      handsortingChange({ target: { value: opt?.value } })
                    }
                    options={[
                      { value: "new_to_old", label: "Newest to Oldest" },
                      { value: "old_to_new", label: "Oldest to Newest" },
                      { value: "low_to_high", label: "Cost: Low to High" },
                      { value: "high_to_low", label: "Cost: High to Low" },
                      { value: "qty_low_to_high", label: "Qty: Low to High" },
                      { value: "qty_high_to_low", label: "Qty: High to Low" },
                    ]}
                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                    closeMenuOnScroll={shouldCloseSelectOnScroll}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  // isSearchable
                  />
                </div>
              </div>
              {/* {location && location.pathname == "/my-inventory" && count >= 0 && (
                <div className="d-flex align-items-center total_item_btn">
                  <button
                    aria-haspopup="true"
                    aria-expanded="false"
                    type="button"
                    className="red-btn btn-sm font-weight-bold"
                  >
                    <span
                      className="font-weight-bold"
                      id="kt_dashboard_daterangepicker_title"
                    >
                      Total added items :{" "}
                    </span>
                    <span
                      className="font-weight-bolder"
                      id="kt_dashboard_daterangepicker_date"
                    >
                      {count !== null ? count : 0}
                    </span>
                  </button>
                </div>
              )} */}
            </div>
          </div>
          {location && location.pathname == "/my-inventory" && (
            <div className="sync-sec-subheader d-flex flex-row sm:flex-col gap-4" id="sync-sec-container">
              {/* <button
                className="red-btn bg-brand-600 hover:bg-brand-700 text-white px-4 py-1.5 rounded-lg text-sm font-semibold transition-colors shadow-sm flex items-center gap-2 whitespace-nowrap"
              >
                Sale Products Price Resync
              </button>
              <button
                className="red-btn bg-brand-600 hover:bg-brand-700 text-white px-4 py-1.5 rounded-lg text-sm font-semibold transition-colors shadow-sm flex items-center gap-2 whitespace-nowrap"
              >
                Products Price Resync
              </button> */}
            </div>
          )}
        </div>
      </div>

    </>
  );
}
